import type { ArchivedMember } from '@qlk/shared';
import { ROLE_LABEL } from '@qlk/shared';
import { Archive } from 'lucide-react';
import { Link } from 'react-router-dom';

import { Avatar, DataTable, EmptyState, ngayGio, type CotBang } from '../../../ui/index.js';

/**
 * Tab "Lưu trữ": nhân sự đã nghỉ, mới nghỉ trước.
 *
 * Mỗi dòng dẫn sang trang hồ sơ **chỉ xem** — ở đây không có nút thao tác nào,
 * kể cả "Khôi phục": khôi phục là việc cần đọc hồ sơ trước, nên nó nằm trong
 * trang hồ sơ chứ không nằm trong bảng.
 */
export function BangLuuTru({ dong, dangTai }: { dong: ArchivedMember[]; dangTai: boolean }) {
  const cot: CotBang<ArchivedMember>[] = [
    {
      key: 'nguoi',
      header: 'Người',
      ghim: true,
      render: (r) => (
        <Link to={`/nhan-su/luu-tru/${r.id}`} className="flex items-center gap-3 text-left">
          <Avatar name={r.name} color={r.avatarColor} size={36} />
          <span className="min-w-0">
            <span className="block truncate font-semibold text-chu underline-offset-2 hover:underline">
              {r.name}
            </span>
            <span className="block truncate text-phu text-chu-mo">{r.email}</span>
          </span>
        </Link>
      ),
    },
    {
      key: 'vaiTro',
      header: 'Vai trò lúc nghỉ',
      render: (r) => r.roles.map((k) => ROLE_LABEL[k]).join(' · ') || '—',
    },
    {
      key: 'kenh',
      header: 'Kênh lúc nghỉ',
      align: 'right',
      render: (r) => <span className="so-lieu">{r.channelCount}</span>,
    },
    {
      key: 'luc',
      header: 'Lưu trữ lúc',
      render: (r) => (r.archivedAt ? ngayGio(r.archivedAt) : '—'),
    },
    { key: 'boi', header: 'Bởi', render: (r) => r.archivedByName ?? '—' },
    {
      key: 'lyDo',
      header: 'Lý do',
      render: (r) => <span className="text-chu-phu">{r.archiveReason ?? '—'}</span>,
    },
  ];

  return (
    <DataTable
      caption="Nhân sự đã lưu trữ"
      columns={cot}
      rows={dong}
      keyOf={(r) => r.id}
      dangTai={dangTai}
      khiRong={
        <EmptyState
          icon={Archive}
          title="Chưa lưu trữ ai"
          description="Nhân sự nghỉ việc được lưu trữ từ hộp thoại sửa thành viên. Dữ liệu lịch sử của họ vẫn xem được ở đây."
        />
      }
    />
  );
}
